module.exports = __webpack_public_path__ + "assets/img/slogan-78313390.png";